import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Nav from "../site/Nav";
import SEO from "../site/SEO";
import Footer from "../site/Footer";

export default function PaymentCancelPage() {
  return (
    <div className="bg-sand-100 text-ink min-h-screen" data-testid="payment-cancel-page">
      <SEO page="/thank-you" title="Checkout cancelled · The Modern Exit" path="/payment/cancel" />
      <Nav />
      <main className="pt-28 sm:pt-32 pb-20 px-5 sm:px-6 md:px-10">
        <div className="max-w-2xl mx-auto border border-sand-300 bg-sand-50 p-8 sm:p-10">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-clay-deep">
            Checkout cancelled
          </p>
          <h1 className="font-display mt-4 text-3xl sm:text-4xl tracking-tight text-ink">
            No charge was made.
          </h1>
          <p className="mt-4 text-ink-muted leading-relaxed max-w-xl">
            You closed the secure checkout before finishing. Nothing was
            charged. Whenever you're ready, pick your package and we'll get you
            set up.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to="/pricing" data-testid="cancel-pricing-cta" className="inline-flex items-center justify-center gap-2 rounded-full bg-ink-deep text-sand-100 px-6 py-3.5 text-[14px] font-medium hover:bg-ink transition-colors min-h-[48px]">
              View pricing <ArrowRight size={15} />
            </Link>
            <Link to="/" className="inline-flex items-center justify-center gap-2 px-4 py-3.5 text-[14px] text-ink hover:text-clay transition-colors">
              <ArrowLeft size={13} /> Back to home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
